const sessionStorageUtils = {
  set(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.warn(`Error setting sessionStorage key "${key}":`, err);
    }
  },

  get(key) {
    try {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (err) {
      console.warn(`Error getting sessionStorage key "${key}":`, err);
      return null;
    }
  },

  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.warn(`Error removing sessionStorage key "${key}":`, err);
    }
  },

  clearAll() {
    try {
      sessionStorage.clear();
    } catch (err) {
      console.warn(`Error clearing sessionStorage:`, err);
    }
  },
};

export default sessionStorageUtils;
